// Async storage interface
interface Storage {
  getItem(key: string): Promise<string | null>;
  setItem(key: string, value: string): Promise<void>;
}

// LocalStorage implementation
export class LocalStorageService implements Storage {
  async getItem(key: string): Promise<string | null> {
    return new Promise((resolve, reject) => {
      try {
        const value = localStorage.getItem(key);
        resolve(value);
      } catch (error) {
        console.error(`Error reading from localStorage for key ${key}:`, error);
        reject(error);
      }
    });
  }

  async setItem(key: string, value: string): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        localStorage.setItem(key, value);
        resolve();
      } catch (error) {
        console.error(`Error writing to localStorage for key ${key}:`, error);
        reject(error);
      }
    });
  }
}
